import React, { useEffect, useState } from "react";
import Movie from "./components/Movie";

function App() {
  // const [term, setTerm] = useState("");

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   fetch(
  //     `https://api.themoviedb.org/3/search/movie?&api_key=04c35731a5ee918f014970082a0088b1&query=${term}`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data.results);
  //       setTerm(data.results.title);
  //     });
  // };

  // const handleChange = (e) => {
  //   setTerm(e.target.value);
  // };

  return (
    <div className="bg-dark">
      <div className="container p-3 center card-deck mb-3">
        {/* <form onSubmit={handleSubmit} className="form-group">
          <input
            type="text"
            onChange={handleChange}
            className="form-control"
            placeholder="Search"
            value={term}
          ></input>
        </form> */}
        <h1 style={{ color: "white" }} className="text-center">
          Top 10 Recent Movies
        </h1>
        <div className="shadow rounded">
          <Movie />
          <p style={{ color: "#ffffff" }} className="text-center m-3">
            Created by Oge Obubu using React.js
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
